// extracted by mini-css-extract-plugin
export var discard = "_1y-4";
export var muiTooltipTooltip = "_1y-6";
export var notificationBar = "_1y-3";
export var notificationContainer = "_1y-2";
export var saveButtonHoverSlotWrapper = "_1y-5";
export var show = "_1y-1";
export var spacer = "_1y-0";